import { render } from "./MarketingRedirect.vue?vue&type=template&id=dca1378e&scoped=true"
import script from "./MarketingRedirect.vue?vue&type=script&lang=js"
export * from "./MarketingRedirect.vue?vue&type=script&lang=js"

import "./MarketingRedirect.vue?vue&type=style&index=0&id=dca1378e&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca1378e"]])

export default __exports__